__turbopack_context__.v({
  "product-badges": "product-badges-component-module-scss-module__JXSima__product-badges",
  "product-badges--product-tile": "product-badges-component-module-scss-module__JXSima__product-badges--product-tile",
  "product-badges__badge": "product-badges-component-module-scss-module__JXSima__product-badges__badge",
  "product-badges__icon": "product-badges-component-module-scss-module__JXSima__product-badges__icon",
  "product-badges__text": "product-badges-component-module-scss-module__JXSima__product-badges__text",
  "product-badges__unavailable": "product-badges-component-module-scss-module__JXSima__product-badges__unavailable",
});
